/**
 * Смена того, кто вошёл, — граница для всей памяти ответов на клиенте.
 *
 * Сервер режет ответы по области чтения ПРИНЦИПАЛА: фермер получает свою
 * землю, район — весь. Память запросов на клиенте (корпус кабинета, наборы
 * реестра, геометрия карты) при этом держится на всё приложение и ключуется
 * срезом, а вход и выход идут переходом без перезагрузки страницы. Без этой
 * границы в одной вкладке районный аккаунт после фермера видел бы на карте
 * только землю фермера — неполную картину под видом всего района, — а фермер
 * после района держал бы на клиенте чужие данные.
 *
 * Поэтому память ответов регистрирует здесь свой сброс, а слой входа сообщает
 * о каждом известном ему принципале. Первое сообщение ничего не сбрасывает:
 * ответы до него получены с той же cookie сессии, что и `/auth/me`. Сбрасывает
 * только СМЕНА — вход, выход или истёкшая сессия. Модуль без зависимостей:
 * его импортируют и память ответов, и слой входа.
 */

const clears = new Set<() => void>();
const listeners = new Set<() => void>();
let epoch = 0;
let known: string | undefined;

/** Зарегистрировать сброс памяти ответов, зависящих от принципала. */
export function onPrincipalChange(clear: () => void): void {
  clears.add(clear);
}

/**
 * Сообщить, кто вошёл сейчас (`null` — аноним). Сбрасывает память, только
 * если принципал сменился относительно последнего известного.
 */
export function notePrincipal(identity: string | null): void {
  const next = identity ?? '';
  if (known === undefined) {
    known = next;
    return;
  }
  if (known === next) return;
  known = next;
  for (const clear of clears) clear();
  epoch += 1;
  for (const listener of listeners) listener();
}

/**
 * Кто вошёл, по последнему сообщению слоя входа (`''` — аноним, `undefined` —
 * ещё не известно). Нужен описи страниц для предзагрузки: опись одного
 * аккаунта не повторяется от имени другого.
 */
export function principalIdentity(): string | undefined {
  return known;
}

/** Номер смены принципала — для подписки экранов (`useSyncExternalStore`). */
export function principalEpoch(): number {
  return epoch;
}

export function subscribePrincipal(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}

/** Только для тестов: забыть последнего известного принципала. */
export function resetPrincipalMemory(): void {
  known = undefined;
}
